import { TextField, Button, CircularProgress, Alert } from "@mui/material";
import { Icon } from "@components/index";
import "./index.scss";

const CredentialsStep = ({
  formData,
  errors,
  loading,
  loginCredsError,
  handleChange,
  handleSubmit,
  passwordVisibilityData,
}) => {
  return (
    <form onSubmit={handleSubmit} className="credentials-form">
      <div className="form-field">
        <label className="field-label">Email Id</label>

        <TextField
          fullWidth
          placeholder="Enter registered email id"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email}
          variant="outlined"
          className="login-input"
          disabled={loading}
        />
      </div>

      <div className="form-field">
        <label className="field-label">Password</label>

        <TextField
          fullWidth
          placeholder="Enter your password"
          name="password"
          type={passwordVisibilityData.showPassword ? "text" : "password"}
          value={formData.password}
          onChange={handleChange}
          error={!!errors.password}
          helperText={errors.password}
          variant="outlined"
          className="login-input"
          disabled={loading}
          slotProps={{
            input: {
              endAdornment: (
                <button
                  type="button"
                  onClick={passwordVisibilityData.togglePasswordVisibility}
                  className="password-toggle-button"
                  aria-label={
                    passwordVisibilityData.showPassword
                      ? "Hide password"
                      : "Show password"
                  }
                  tabIndex={-1}
                >
                  <Icon
                    iconName={
                      passwordVisibilityData.showPassword
                        ? "eyeClose"
                        : "eyeOpen"
                    }
                    width={20}
                    height={20}
                    className="eye-button"
                  />
                </button>
              ),
            },
          }}
        />
      </div>

      {loginCredsError && (
        <Alert severity="error" className="login-alert">
          {loginCredsError}
        </Alert>
      )}

      <Button
        type="submit"
        fullWidth
        variant="contained"
        size="large"
        className="continue-button"
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Continue"}
      </Button>
    </form>
  );
};

export default CredentialsStep;
